import { useEffect } from "react";

function useRunOnPageLeave(fn: (e: BeforeUnloadEvent | PopStateEvent | Event) => void) {
  useEffect(() => {
    window.addEventListener('popstate', fn);
    window.addEventListener('unload', fn);

    return () => {
      window.removeEventListener('popstate', fn);
      window.removeEventListener('unload', fn);
    };
  }, [fn]);
}

export default useRunOnPageLeave;
